import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/* Redux */
import { Provider } from "react-redux";
import store from "./redux/store";
/* End Redux */

/* KeyCloak */
import Keycloak from "keycloak-js";
import { ReactKeycloakProvider } from "@react-keycloak/web";
/* End KeyCloak */

/* AgGrid */
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";

LicenseManager.setLicenseKey(
  "CompanyName=GLOBAL OMNIUM IDRICA, S.L.U.,LicensedGroup=GoAigua,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-019519,ExpiryDate=28_September_2022_[v2]_MTY2NDMxOTYwMDAwMA==7ba61952332694c12810eba00b412622"
);

ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
